import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UserService } from '../shared/services/user.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(public inj: Injector) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const userService = this.inj.get(UserService);
        return next.handle(request).pipe(catchError(err => {

            //if unathorized, logout and redirect to login page
            if ([401, 403].includes(err.status)) {
                if (userService.token &&
                    request.headers.get('Authorization') === `Bearer ${userService.token}`) {
                    userService.redirectToLogin();
                }
            }
            // Any other error (e.g. a 500) must propagate to the caller so it can show a
            // real error message. This used to silently re-issue the same request via
            // `next.handle(request)` here, which duplicated side-effecting calls (like
            // campaign send) and could mask a genuine failure behind a lucky retry.
            return throwError(err);
        }))
    }
}
